module.exports = __webpack_public_path__ + "static/media/Filter.bec856b7.svg";